import React from 'react';
import styled from '@emotion/styled';
import Select from 'react-select';
import { Box, FormLabel, Text } from '@chakra-ui/react';
import { FormikTouched, FormikErrors } from 'formik';

interface Props {
  name: string;
  errors?: any;
  editMember?: boolean;
  onBlur?: {
    (e: React.FocusEvent<any>): void;
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
  };
  setFieldValue?: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => Promise<void> | Promise<FormikErrors<any>>;
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
  value?: any;
  options: { [x: string]: any }[];
  label?: string;
  placeholder?: string;
  multiSelect?: boolean;
  disabled?: boolean;
  boxProps?: Record<string, unknown>;
  rules?: any;
  labelProps?: Record<string, unknown>;
  optionLabel?: string;
  optionValue?: string;
  capitalizeLabel?: boolean;
  noValues?: boolean;
  [x: string]: any;
  pastEvents?: boolean;
  customStyles?: any; // Custom styles for react-select
}

const SelectDropdown: React.FC<Props> = ({
  name,
  options = [],
  label,
  placeholder,
  multiSelect = false,
  boxProps,
  labelProps,
  errors = [],
  disabled = false,
  editMember,

  optionLabel = 'label',

  noValues = true,
  value,
  pastEvents,
  onBlur,
  touched,
  customStyles,
  ...props
}) => (
  <Box {...boxProps}>
    {label && <FormLabel {...labelProps}>{label}</FormLabel>}
    {!pastEvents ? (
      <StyledSelect
        classNamePrefix="Select"
        placeholder={placeholder}
        options={options}
        isSearchable={false}
        isMulti={multiSelect}
        isDisabled={disabled}
        controlShouldRenderValue={noValues}
        menuPlacement="auto"
        getOptionLabel={(option: any) => option[optionLabel]}
        value={value}
        onBlur={onBlur}
        styles={customStyles}
        {...props}
      />
    ) : (
      <PastEventsStyledSelect
        classNamePrefix="Select"
        placeholder={placeholder}
        options={options}
        isSearchable={false}
        isMulti={multiSelect}
        isDisabled={disabled}
        controlShouldRenderValue={noValues}
        menuPlacement="auto"
        getOptionLabel={(option: any) => option[optionLabel]}
        value={value}
        onBlur={onBlur}
        styles={customStyles}
        {...props}
      />
    )}
    {touched && errors && (
      <Text mt="0.5rem" color="red.500">
        {errors}
      </Text>
    )}
  </Box>
);

const StyledSelect = styled(Select)`
  .Select__control {
    height: 21px;
    border: none;
    width: 100%;
    cursor: pointer;
    font-size: 14px;
  }
  .Select__single-value {
    color: #037fa1;

    font-weight: 700;
  }
  .Select__value-container {
    padding-right: 0px;
  }
  .Select__placeholder {
    color: #3d3d5f;
    font-size: 14px;
    padding-right: 5px;
    font-weight: 700;
  }
  .Select__indicator {
    color: #3d3d5f;
    padding-left: 0px;
    padding-right: 20px;
    font-size: 14px;
    :hover {
      color: #56b6a5;
    }
  }

  .Select__control--is-focused {
    outline: 0px;
    border: none;
    box-shadow: none !important;
    ::placeholder {
      color: red;
    }
  }
  .Select__control:hover {
    outline: 0px;
    border: none;
    border-color: #666666 !important;
  }

  .Select__option--is-focused {
    background-color: #f2ebf4;
  }

  .Select__control--menu-is-open {
    padding: 0px;
    margin: 0px;
  }

  .Select__menu-list {
    padding: 0px;
    margin: 0px;
  }
  .Select__option--is-selected {
    background-color: #56b6a5;
    font-weight: 700;
  }

  .Select__indicator-separator {
    display: none;
  }

  .Select__menu {
    color: #0f172a;
    z-index: 999;
    min-width: 100%;
    width: auto;
    text-align: left;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    margin-top: 2px;
  }
`;

const PastEventsStyledSelect = styled(Select)`
  .Select__control {
    height: 21px;
    border: none;
    width: 125px;
    cursor: pointer;
    font-size: 14px;
  }
  .Select__single-value {
    color: #56b6a5;

    font-weight: 700;
  }
  .Select__value-container {
    padding-right: 0px;
  }
  .Select__placeholder {
    color: #3d3d5f;
    font-size: 14px;
    padding-right: 5px;
    font-weight: 700;
  }
  .Select__indicator {
    color: #3d3d5f;
    padding-left: 0px;
    padding-right: 20px;
    font-size: 14px;
    :hover {
      color: #56b6a5;
    }
  }

  .Select__control--is-focused {
    outline: 0px;
    border: none;
    box-shadow: none !important;
    ::placeholder {
      color: red;
    }
  }
  .Select__control:hover {
    outline: 0px;
    border: none;
    border-color: #666666 !important;
  }

  .Select__option--is-focused {
    background-color: #f2ebf4;
  }

  .Select__control--menu-is-open {
    padding: 0px;
    margin: 0px;
  }

  .Select__menu-list {
    padding: 0px;
    margin: 0px;
  }
  .Select__option--is-selected {
    background-color: #56b6a5;
    font-weight: 700;
  }

  .Select__indicator-separator {
    display: none;
  }

  .Select__menu {
    color: #0f172a;
    z-index: 999;
    min-width: 100%;
    width: auto;
    text-align: left;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    margin-top: 2px;
  }
`;

export default SelectDropdown;
